import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for outlined input style.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiOutlinedInputStyle = (theme: Theme): ThemeStyle => {
  return {
    root: {
      outline: 'none',

      '&:hover $notchedOutline': {
        borderColor: theme.palette.grey['300'],
      },

      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
      },

      '& .MuiInputAdornment-root .MuiIconButton-root': {
        color: theme.palette.common.black,
      },

      '&$focused .MuiInputAdornment-root .MuiIconButton-root': {
        color: theme.palette.primary.main,
      },
    },
    input: {
      padding: 12,
    },
    notchedOutline: {
      borderColor: theme.palette.grey['300'],
      top: -6,
    },

    adornedEnd: {
      paddingRight: 8,
    },
  };
};
